import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { LoaderService } from '../../../../common/services/loader.service';
import { ContactService } from '../../../services/contacts.service';
import { AuthService } from '../../../../services/auth.service';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import { Signature, SignedReportModel } from '../../../../common/models/signature.model';
import { SignerType, Contact } from '../../../models/contact.model';
import { Subscription, concat } from 'rxjs';
import { first, finalize, concatMap, filter } from 'rxjs/operators';
import { ReportSelectorService } from '../../../../form-controls/services/report-selector.service';
/*import { NgbDateNativeUTCAdapter } from '@ng-bootstrap/ng-bootstrap';*/
import { ChiefsOrderService } from '../../../../services/chiefsOrder.service';
import { DynamicDialogService } from '../../../../core/services/dynamic-dialog.service';
import { Dialog, DialogButton } from '../../../../core/models/dialog.model';

@Component({
    selector: 'co-signature.component',
    templateUrl: './co-signature.component.html',
    styleUrls: ['./co-signature.component.scss'],
    standalone: false
})
export class CoSignatureComponent implements OnInit,AfterViewInit, OnDestroy {
    flowId: string = '';
    public signer: Signature = {
        id:'',
        userId: '',
        legalName: "",
        signerType: SignerType.None,
        authority: "",
        flowId: ""
    };

    public date = new Date();
    public chief: Contact[];    
    public divisionName = 'Division of Oil and Gas Resource Management';
    public profile: Contact[];
    public showSignatureError: boolean = false;
    public signatureError = "An error has occurred in recording the signature.  Please try again.";
    public signedRes = {};
    public recordRes = {};
    subscription = new Subscription();
    public signerParam: string;
    public signersList: string[];

    successDialog: Dialog = new Dialog("The Chief's Order was signed successfully.", [new DialogButton("OK", true, () => this.onSignSuccessDialogConfirm())]);

    constructor(public readonly loader: LoaderService, public readonly contacts: ContactService,
        public authService: AuthService, public activeRoute: ActivatedRoute,
        public reportsService: ReportSelectorService, public coService: ChiefsOrderService,
        public dialogService: DynamicDialogService, public readonly router: Router) { }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    ngOnInit() {
        this.loader.toggleLoader(true);
        if (this.activeRoute.snapshot.paramMap.get('coinstanceid')) {
            this.flowId = this.activeRoute.snapshot.paramMap.get('coinstanceid');
        }           

        this.profile = this.activeRoute.snapshot.data['contactProfile'];
        this.chief = this.activeRoute.snapshot.data['contactAuthority'];  
        this.signersList = this.activeRoute.snapshot.data['signersList'];
        this.loader.toggleLoader(false);   

        this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe((routerEvent: NavigationStart) => {
            this.subscription.unsubscribe();
        });
    }
    
    ngAfterViewInit() {
        this.setSigner();
    }

    setSigner(): void {

        this.signer.userId = this.authService.User.id;
        this.signer.signerType = this.authService.User.authority;
        this.signer.flowId = this.flowId;
        this.signer.authority = this.signer.signerType;
        this.signer.legalName = this.chief[0].displayName;
        this.signer.dateSigned = new Date();
    }

    get hasAuthority(): boolean {

        return this.signersList.indexOf(this.authService.User.authority) > -1 ? true : false;
    }

    get delegateLine(): string {
        let result: string = '';
        result += this.signer.authority === 'Deputy' ? 'Deputy Chief' : this.signer.authority;
        result += ` ${this.profile[0].displayName} for `;
        return result;
    } 
    get chiefFullAuthorityText(): string {
        return this.isDelegateSignature ? `${this.delegateLine}${this.chief[0].fullLegalName}` : this.chief[0].fullLegalName;
    }

    get chiefLine(): string {
        return `${this.chief[0].fullLegalName}, Chief of the `;
    }
    get signature(): string {
        if (this.signer.signerType === SignerType.None) return "";
        return `/s/ ${this.chief[0].displayName}`;
    }

    get signatureDate(): string {
        if (this.signer.signerType === SignerType.None) return "";
        return `${this.signer.dateSigned}`;
    }
    get isDelegateSignature(): boolean {
        return this.signer.signerType === SignerType.Deputy || this.signer.signerType === SignerType.Assistant;
    }

    public sign(): void {
        if (!this.profile) return;
        this.loader.toggleLoader(true);

        let fullLegalName = this.chief[0].fullLegalName;
        if (!fullLegalName) {
            fullLegalName = `${this.chief[0].firstName} `;
            if (this.chief[0].middleInitial)
                fullLegalName += `${this.chief[0].middleInitial}. `;
            fullLegalName += `${this.chief[0].lastName}`;
            if (this.chief[0].suffix)
                fullLegalName += ` ${this.chief[0].suffix}`;
        }

        let signatureObj = {
            userId: this.authService.User.id,
            legalName: fullLegalName,
            dateSigned: new Date(),
            flowId: this.flowId,
            authority: this.signer.authority,
            signerType: this.signer.signerType,
            signatureText: fullLegalName,
        } as Signature;

        this.subscription.add(this.coService.saveChiefsSignature(signatureObj).subscribe((result) => {
            }, (error) => {
                this.showSignatureError = true;
                this.loader.toggleLoader(false);
            }, () => {

                    this.showSignatureError = false;
                    this.loader.toggleLoader(false);

                    this.successDialog.toggleDialog(true);
                    this.dialogService.updateDialog(this.successDialog);
                }));
    }

    public onSignSuccessDialogConfirm(): void {
        this.router.navigate(["/dashboard/view/ricsDashboard"]);
    }

}
